<template>
    <div>
        <b-img fluid :src=image :alt=alt />
    </div>
</template>

<script>
    export default {
        name: 'HeroBanner',
        props:{
            image: String,
            alt: String
        }
    }
</script>